module.exports = __webpack_public_path__ + "static/media/ami_de.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_de.png
// module id = 567
// module chunks = 1